/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';
import { isCallcenterLoggedIn, getCallcenterUser } from './callcenterService';

const baseUrl = `${process.env.BACKEND_API_BASE_URL}/jobs.php`;

const getToken = () => (isCallcenterLoggedIn() ? getCallcenterUser() : getLoginUser()).token;

export const smartMatchService = {
  // Live detection flags (cheap, no Matrix) — polled to drive the banner/pill.
  get_smart_match_flags: async (data = {}) =>
    axios.get(baseUrl, {
      params: {
        method: 'get_smart_match_flags',
        token: getToken(),
        ...data, // { dbname } for call center
      },
    }),
  // On-demand fleet scoring (metered) — called when the modal opens.
  get_smart_match_candidates: async (jobId, data = {}) =>
    axios.get(baseUrl, {
      params: {
        method: 'get_smart_match_candidates',
        job_id: jobId,
        token: getToken(),
        ...data,
      },
    }),
};
